import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { findValidI18nKey } from 'pricing-pages-lib/utils/languageUtils';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import Breakpoints from '../../constants/Breakpoints';
import { ADDITIONAL_SUBSCRIPTION } from './CommerceFeatureTableConfig';
import CommerceFeatureTableCell from './CommerceFeatureTableCell';
import { FREE } from 'self-service-api/constants/ProductLevels';
const FeatureName = styled.div.attrs({
  tabIndex: -1
}).withConfig({
  displayName: "CommerceFeatureTableRow__FeatureName",
  componentId: "sc-1b7atvo-0"
})(["font-weight:600;padding-left:30px;", ""], Breakpoints.tabletPortrait(_t || (_t = _`
    padding-left: 0;
  `)));

const CommerceFeatureTableRow = ({
  feature,
  accessLevels,
  productLevels,
  isSuite = false
}) => {
  const history = useHistory();
  const featureNameKey = findValidI18nKey([`enrolledProductLine.features.${feature.shortName}.name`]);
  if (!featureNameKey) return null;
  const tooltipKey = findValidI18nKey([`enrolledProductLine.features.${feature.shortName}.description.${COMMERCE}`, `enrolledProductLine.features.${feature.shortName}.description.${COMMERCE}_jsx`, `enrolledProductLine.features.${feature.shortName}.description.default_jsx`]);
  const {
    embeddedLink
  } = feature;

  const handleLinkClick = () => {
    if (embeddedLink) {
      const {
        isExternal,
        name,
        url
      } = embeddedLink;
      getUsageTracker().track(isExternal ? 'externalLinkClick' : 'internalLinkClick', {
        name,
        url
      });

      if (!isExternal && url) {
        history.push(url);
      }
    }
  };

  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx("th", {
      scope: "row",
      children: /*#__PURE__*/_jsx("div", {
        className: "align-center",
        children: /*#__PURE__*/_jsx("span", {
          style: {
            cursor: 'help'
          },
          children: tooltipKey ? /*#__PURE__*/_jsx(UITooltip, {
            use: "longform",
            title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: tooltipKey,
              options: {
                onClick: handleLinkClick,
                href: embeddedLink && embeddedLink.url,
                external: embeddedLink && embeddedLink.isExternal
              },
              elements: {
                Link: UILink
              }
            }),
            children: /*#__PURE__*/_jsx(FeatureName, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: featureNameKey
              })
            })
          }) : /*#__PURE__*/_jsx(FeatureName, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: featureNameKey
            })
          })
        })
      })
    }), isSuite && productLevels ? productLevels.map(level => {
      return /*#__PURE__*/_jsx(CommerceFeatureTableCell, {
        accessLevel: level === FREE ? FREE : ADDITIONAL_SUBSCRIPTION,
        feature: feature,
        productLevel: level,
        isSuite: true,
        showTooltip: true
      }, `${feature.shortName}-${level}`);
    }) : accessLevels.map(level => {
      return /*#__PURE__*/_jsx(CommerceFeatureTableCell, {
        feature: feature,
        accessLevel: level,
        showTooltip: false
      }, `${feature.shortName}-${level}`);
    })]
  }, `${feature.shortName}-row`);
};

export default CommerceFeatureTableRow;